export const companies=[
  {
    img: 'clients/liberty-insurance.png',
    title: 'Liberty Insurance',
    width: 130,
    height: 80
  },
  {
    img: 'clients/bmw.png',
    title: 'BMW',
    width: 70,
    height: 80
  },
  {
    img: 'clients/dekra.png',
    title: 'Dekra',
    width: 70,
    height: 80
  },
  {
    img: 'clients/Nissan-logo.png',
    title: 'Nissan',
    width: 110,
    height: 80
  },
  {
    img: 'clients/Toyota.png',
    title: 'Toyota',
    width: 70,
    height: 80
  },
  {
    img: 'clients/Univeral-Sompo-Logo.png',
    title: 'Sompo',
    width: 150,
    height: 80
  },
  {
    img: 'clients/Fixico-logo.png',
    title: 'Fixico',
    width: 80,
    height: 70
  },
  {
    img: 'clients/holiday-cars.png',
    title: 'Holiday Cars',
    width: 140,
    height: 80
  },
  {
    img: 'clients/ntt-data-services.png',
    title: 'NTT Data Services',
    width: 90,
    height: 80
  },
  {
    img: 'clients/Zurich.jpg',
    title: 'Zurich',
    width: 80,
    height: 80
  },
  {
    img: 'clients/APG-AUTO-PARTS-GROUP-LOGO.webp',
    title: 'APG',
    width: 100,
    height: 80
  },
  {
    img: 'clients/vmg.png',
    title: 'VMG',
    width: 130,
    height: 80
  },
];
export const productFeatures = [
  {
    title: 'AI Vehicle Damage Detection',
    text: 'Identify and localise visible damage in vehicle photos and videos. Help inspection teams document scratches, dents and other detectable damage with greater consistency.',
    buttonText: 'Read More about Damage Detection',
    img: 'vehicle-damage.svg',
    mainImg: 'Assess-vehicle-damage-within-seconds.svg',
    link: '/damage-detection'
  },
  {
    title: 'Automated Inspection Reports',
    text: 'Convert inspection inputs into structured reports that help teams review vehicle condition, document findings and share assessment information across business workflows.',
    buttonText: 'Read More about Claim Assessment',
    img: 'Automate-inspections.svg',
    mainImg: 'Automate-inspections-with-fixed-cameras.svg',
    link: '/claim-estimation'
  },
  {
    title: 'Image Fraud Screening',
    text: 'Flag supported indicators of suspicious or manipulated inspection images to help teams identify submissions that may require further review.',
    buttonText: 'Read More about Fraud Detection',
    img: 'real-time-fraud.svg',
    mainImg: 'Real time fraud detection.svg',
    link: '/fraud-detection'
  },
  {
    title: 'Image Quality Assessment',
    text: 'Check inspection images for quality issues that could affect analysis. Help users identify missing, unclear or unsuitable images and capture better evidence.',
    buttonText: 'Read More about Photo Quality',
    img: 'vehicle-quality.svg',
    mainImg: "Analyze Your vehicle’s image quality.svg",
    link: '/photo-quality'
  },
  {
    title: 'Damage Assessment and Repair Estimates',
    text: 'Support damage evaluation and repair estimation workflows using AI-generated inspection findings and available vehicle information.',
    buttonText: 'Read More about Claim Estimation',
    img: 'fixed-cameras.svg',
    mainImg: 'Generate Claim Estimates in seconds.svg',
    link: '/claim-estimation'
  },
  {
    title: 'Vehicle Data Extraction',
    text: 'Extract supported vehicle identifiers and document information using OCR to reduce manual data entry and connect inspection results with relevant records.',
    buttonText: 'Read More about Photo Video Capture',
    img: 'claim-estimates.svg',
    mainImg: 'Auto-scan-important-information.svg',
    link: '/photo-video-capture'
  }
]
export const usersCard = [
 {
  cardImg: 'Insurers.svg',
  userType: 'Vehicle Inspection for Insurance',
  altText: 'AI vehicle inspection for insurance claims automation',
  text: 'AI-powered damage detection and inspection reports for motor insurance claims.',
  cta: 'Explore Insurance Inspection Solutions',
  link: '/insurance'
 },
 {
  cardImg: 'fleetmanagement.svg',
  userType: 'Vehicle Inspection Software for Fleet Management',
  altText: 'Vehicle inspection software for fleet management',
  text: 'Standardise vehicle checks, document damage and maintain consistent fleet records.',
  cta: 'Explore Fleet Inspection Software',
  link: '/fleet-inspection-software'
 },
 {
  cardImg: 'Car rentals.svg',
  userType: 'AI Inspections for Car Rental and Leasing',
  altText: 'AI vehicle inspection for car rental and leasing',
  text: 'Document vehicle condition at pickup, return and lease-end inspections.',
  cta: 'Explore Rental & Leasing Inspections',
  link: '/car-rental'
 },
 {
  cardImg: 'Vehicle Re-marketing.svg',
  userType: 'Vehicle Inspection for Remarketing',
  altText: 'AI-verified vehicle condition reports for vehicle remarketing',
  text: 'Document vehicle condition for evaluation, auction and resale workflows.',
  cta: 'Explore Remarketing Solutions',
  link: '/vehicle-remarketing'
 },
 {
  cardImg: 'white-truck.svg',
  userType: 'Smarter Inspections for Commercial Trucks',
  altText: 'AI truck inspection software for commercial fleets',
  text: 'AI-powered damage detection for commercial truck and fleet inspections.',
  cta: 'Explore Truck Inspection Software',
  link: '/truck-inspection-software'
 },
 {
  cardImg: 'bike.svg',
  userType: 'Vehicle Inspections for Motorcycles',
  altText: 'AI motorcycle inspection software',
  text: 'AI-powered damage detection for motorcycle condition assessments and inspections.',
  cta: 'Explore Motorcycle Inspection Software',
  link: '/motorcycle-inspection-software'
 }
]

// Homepage FAQ (source: "Homepage LP Copy" PDF, Fold 7). English-only; the
// shared /faq page keeps its own set.
export const homeFaqs = [
  {
    Q: 'What is vehicle inspection software?',
    A: ['Vehicle inspection software helps businesses assess vehicle condition, record damage and maintain inspection reports digitally. It replaces parts of the manual process with a more consistent way to capture, review and share inspection information.'],
  },
  {
    Q: 'How does Inspektlabs detect vehicle damage?',
    A: ['Inspektlabs analyses vehicle photos and videos to identify visible damage and document the findings. This helps inspection teams review vehicle condition without having to assess every image entirely from scratch.'],
  },
  {
    Q: 'Can I inspect a vehicle using photos or videos?',
    A: ['Yes. Inspektlabs supports inspections using vehicle photos and videos, making it possible to assess vehicle condition remotely in supported workflows. The quality of the results depends on the images captured, vehicle coverage and inspection conditions.'],
  },
  {
    Q: 'How reliable are the inspection results?',
    A: ['Results depend on factors such as image quality, lighting, the type of damage and how clearly the affected area is captured. For important decisions, inspection findings can be reviewed alongside other available evidence and the team’s assessment process.'],
  },
  {
    Q: 'How can Inspektlabs help with insurance claims?',
    A: ['Vehicle damage assessment is an important part of the claims process. Inspektlabs helps insurers review vehicle images, document visible damage and generate inspection reports, reducing some of the manual work involved in assessing claims.'],
  },
  {
    Q: 'Can the platform identify suspicious inspection images?',
    A: ['The platform can help flag supported signs of image manipulation or suspicious submissions for further review. These findings help claims and inspection teams decide when additional verification may be needed.'],
  },
  {
    Q: 'Which businesses can use Inspektlabs?',
    A: ['Inspektlabs supports vehicle inspection workflows across motor insurance, fleet management, car rental and leasing, and vehicle remarketing. The platform can be used wherever businesses need to assess vehicle condition and maintain inspection records.'],
  },
  {
    Q: 'Can Inspektlabs work with our existing systems?',
    A: ['Integration requirements vary depending on your current systems and inspection workflow. Contact our team to discuss your requirements, available integration options and how the platform could fit into your existing processes.'],
  },
  {
    Q: 'Does using Inspektlabs mean we no longer need physical inspections?',
    A: ['Not necessarily. Remote inspections can reduce the need for manual checks in suitable situations, but some vehicles or types of damage may still require an in-person assessment. The right approach depends on your business process and inspection requirements.'],
  },
  {
    Q: 'How long does it take to implement Inspektlabs?',
    A: ['The timeline depends on your use case, integration requirements and the level of customisation needed. Our team can discuss your requirements and outline the implementation process during an initial conversation.'],
  },
]
export const features = [
  {
    title: {
      "en": 'Damage Detection', 
      "es": "Detección de daños",
      "pt": "Detecção de danos"
    },
    text: {
      "en": 'Detect 21 types of damages across metal, plastic, fiber, glass and rubber parts', 
      "es": "Detecta 21 tipos de daños en piezas de metal, plástico, fibra, vidrio y caucho.",
      "pt": "Detecta 21 tipos de danos em peças de metal, plástico, fibra, vidro e borracha."
    },
    img: 'damage-detection.svg',
    path: '/damage-detection',
    bgColor: '#fff',
    action: true,
  },
  {
    title: {
      "en": 'Fraud Detection',
      "es": "Detección de fraude",
      "pt": "Detecção de fraudes"
    },
    text: {
      "en": 'Specialised fraud detection using photos/videos e.g., old/prior damages, metadata analysis',
      "es": "Detección de fraude especializada mediante fotografías/vídeos, por ejemplo, daños antiguos/anteriores, análisis de metadatos",
      "pt": "Detecção especializada de fraudes usando fotos/vídeos, como danos antigos/anteriores, análise de metadados"
    },
    img: 'fraud-detection.svg',
    path: '/fraud-detection',
    bgColor: '#fbfbfb',
    action: true,
  },
  {
    title: {
      "en": 'Claim Assessment',
      "es": "Evaluación de reclamos",
      "pt": "Avaliação de sinistros"
    },
    text: {
      "en": "Claim estimation & review products customised for each market's repair practices",
      "es": "Productos de estimación y revisión de reclamos personalizados para las prácticas de reparación de cada mercado.",
      "pt": "Produtos de estimativa e revisão de sinistros personalizados para as práticas de reparo de cada mercado."
    },
    img: 'claim.svg',
    path: '/claim-estimation',
    bgColor: '#fff',
    action: true,
  },
  {
    title: {
      "en": 'Text Scanning',
      "es": "Escaneo de texto",
      "pt": "Escaneamento de texto"
    },
    text: {
      "en": 'Auto-read Odometer, VIN, License plate or any other text on the vehicle',
      "es": "Odómetro de lectura automática, VIN, matrícula o cualquier otro texto en el vehículo",
      "pt": "Leitura automática de odômetro, VIN, placa ou qualquer outro texto no veículo"
    },
    img: 'text-scanning.svg',
    path: '/',
    bgColor: '#fbfbfb',
    action: false,
  },
  {
    title: {
      "en": 'Photo & Video Capture App for Vehicle Inspection',
      "es": "Aplicación de captura de fotografías y vídeos para inspección de vehículos",
      "pt": "Aplicativo de captura de fotos e vídeos para inspeção de veículos"
    },
    text: {
      "en": 'Web apps for high quality photo and video capture by the end customer',
      "es": "Aplicaciones web para captura de fotografías y vídeos de alta calidad por parte del cliente final",
      "pt": "Aplicativos web para captura de fotos e vídeos de alta qualidade pelo cliente final"
    },
    img: 'photo-video-capture-2.svg',
    path: '/photo-video-capture',
    bgColor: '#fff',
    action: true,
  },
  {
    title: {
      "en": 'Real Time Guidance with Vehicle Inspection App',
      "es": "Orientación en tiempo real con la aplicación de inspección de vehículos",
      "pt": "Orientação em tempo real com o aplicativo de inspeção de veículos"
    },
    text: {
      "en": 'Real time feedback to customers on quality of captured photos/videos',
      "es": "Comentarios en tiempo real a los clientes sobre la calidad de las fotos/vídeos capturados.",
      "pt": "Feedback em tempo real para os clientes sobre a qualidade das fotos/vídeos capturados."
    },
    img: 'real-time-guidance.svg',
    path: '/',
    bgColor: '#fbfbfb',
    action: false,
  },
];

export const whyCards = [
  {
    title: {
      "en": 'Accurate',
      "es": "Preciso",
      "pt": "Preciso"
    },
    text: {
      "en": '95-99% accuracy in damage detection',
      "es": "95-99% de precisión en la detección de daños",
      "pt": "95-99% de precisão na detecção de danos"
    },
    img: 'accurate.svg',
  },
  {
    title: {
      "en": 'Quick',
      "es": "Rápido",
      "pt": "Rápido"
    },
    text: {
      "en": 'It takes us a few seconds to assess a vehicle',
      "es": "Tardamos unos segundos en valorar un vehículo",
      "pt": "Levamos alguns segundos para avaliar um veículo"
    },
    img: 'quick.svg',
  },
  {
    title: {
      "en": 'Secure GDPR',
      "es": "Secure GDPR",
      "pt": "Seguro GDPR"
    },
    text: {
      "en": 'GDPR compliant, secure AWS/Azure cloud',
      "es": "Nube AWS/Azure segura y compatible con GDPR",
      "pt": "Nuvem segura AWS/Azure compatível com GDPR"
    },
    img: 'secure-gdpr.svg',
  },
  {
    title: {
      "en": 'No manual setup',
      "es": "Sin configuración manual",
      "pt": "Sem configuração manual"
    },
    text: {
      "en": 'Our APIs are easy to integrate with any car inspection tool',
      "es": "Nuestras API son fáciles de integrar con cualquier herramienta de inspección de automóviles",
      "pt": "Nossas APIs são fáceis de integrar com qualquer ferramenta de inspeção de veículos"
    },
    img: 'no-manual-setup.svg',
  },
];
export const partners = [
  {
      "name": {
          "en": "Investors",
          "es": "Inversores",
          "pt": "Investidores"
      },
      "logo": [
        {
          img: "techstars.png",
          name: "Techstars",
        },
        {
          img: "Barclays-Logo.png",
          name: "Barclays",
        },
        {
          img: "titan-capital.jpg",
          name: "Titan Capital",
          flip: 'true'
        },
        {
          img: "bettercapital.svg",
          name: "Better Capital",
        },
      ]
  },
  {
      "name": {
          "en": "Partners",
          "es": "Socios",
          "pt": "Parceiros"
      },
      "logo": [
        {
          img: "mitchell.png",
          name: "Mitchell",
        },
        {
          img: "gt-motive.png",
          name: "GT Motive",
        },
        {
          img: "plug-and-play.jpg",
          name: "Plug and Play",
          flip: 'true'
        },
        {
          img: "Amazon-Web-Services AWS.png",
          name: "Amazon Web Services",
          flip: 'false',
          width: 155,
          height:45
        },
        {
          img: "Microsoft.png",
          name: "Microsoft",
          width: 155,
          height: 45
        },
      ]
  }
];
export const testimonials = [
  {
    id: 0,
    name: 'Michel Houthoff',
    altName: 'HolidayCars',
    position: 'COO/CTO; HolidayCars',
    text: "By leveraging Inspektlabs' technology, HolidayCars.com can deliver detailed inspection reports, allowing customers to use this information as a reference and enjoy a hassle-free rental experience",
    img: 't0.jpeg',
    flip: 'false',
  },
  {
    id: 1,
    name: 'Joris van Poppel',
    altName: 'Fixico',
    position: 'Chief Product Officer; Fixico',
    text: 'In the past two years, our collaboration with Inspektlabs helped us to further optimize the quality of our digital damage assessment enabling our repairers to provide top quality repairs for our customers',
    img: 'Fixico-logo.png',
    flip: 'false',
  },
  {
    id: 2,
    name: 'Mika Hasegawa',
    altName: 'NTT Data',
    position: 'NTT Data',
    text: 'We believe that the greatest strength of their technology is the AI accuracy with a large dataset of over several million images. In fact, the technical evaluation confirmed that their AI accuracy was very high and practical enough',
    img: 't2.jpg',
    flip: 'false',
  },
  {
    id: 3,
    name: 'Marco Moreno',
    altName: 'AGE',
    position: 'CEO and Chairman; AGE',
    text: 'Inspektlabs software offers + 95% accuracy, and we hope this will also advance our sustainability commitment, Repair before Replace.',
    img: 't3.png',
    flip: 'false',
  },
  {
    id: 4,
    name: 'Vikram Jain',
    altName: 'Universal Sompo Group',
    position: 'CTO; Universal Sompo Group',
    img: 'sompo-logo.png',
    flip: 'false',
    text: "Inspektlabs has assisted us in enhancing our inspection process at Universal Sompo General Insurance. Their automated inspection solution provides comprehensive coverage for both cars and motorbikes. With custom workflows designed to handle inspections from any source – be it customer self-inspections, vendor checks, or OEM reviews – their platform has streamlined our process, allowing us to manage inspections more efficiently."
  },
  {
    id: 6,
    name: 'Danielle Corby',
    altName: 'VMG',
    position: 'CEO; VMG',
    text: 'Working with Inspeklabs has made a real difference for vMobility, allowing us to deliver an optimised and streamlined repair process. The team at Inspeklabs have been responsive and supportive throughout our integration journey and this approach has been key to the success of the partnership so far. We are excited to keep building on the partnership as we continue to innovate and improve our solutions for the benefit of our clients and their customers.',
    img: 'vmg-logoo.png',
    flip: 'false'
  },
  {
    id: 7,
    name: 'DEKRA Automotive',
    altName: 'Dekra',
    position: '',
    img: 'Dekra-logo.png',
    flip: 'false',
    text: "As a leading damage assessment company in Europe, DEKRA is continuously looking for ways to enhance its services. By integrating Inspektlabs’ digital inspection solution, we’ve significantly streamlined our processes for insurers. The automated visual inspections have greatly reduced claim processing times without compromising quality or accuracy. Inspektlabs is a valuable partner for us in the digital transformation of damage assessment workflows. DEKRA Automotive from the Netherlands"
  },
  {
    id: 8,
    name: 'Auto Parts Groups, Australia',
    altName: 'APG',
    position: '',
    img: 'APG Australia-logo.png',
    flip: 'false',
    text: "Inspektlabs has been a game changer for APG. Their platform has streamlined our recycled parts product line, allowing us to assess quality with consistency, speed, and confidence. The automation and accuracy it provides has significantly improved how we manage inventory and meet customer expectations. Inspektlabs has helped us lift the standard of recycled parts in the market, and we’re proud to be working with a partner that shares our commitment to innovation and quality."
  },
  {
    id: 9,
    name: 'Solidarity',
    altName: 'Solidarity',
    position: '',
    img: 'Solidarity-logo.png',
    flip: 'false',
    text: "Our inspection workflow is now 100% digital. Inspektlabs’ AI-powered inspections have fully replaced physical checks, helping us reduce turnaround time while maintaining accuracy and consistency.",
  },
  {
    id: 10,
    name: 'Generali Portugal',
    altName: 'Generali Portugal',
    position: 'Rui Emídio, Non-Life Offer – Motor & P&C',
    img: 'Generali-Portugal logo.jpeg',
    flip: 'false',
    text: "Inspektlabs helped us streamline underwriting and inspection workflows for selected motor insurance risk segments at Generali Tranquilidade, Portugal, part of Generali Group, a leading insurance player in Europe. The solution contributed to reducing, by several days, underwriting timelines for own-damage motor insurance, improving time-to-policy issuance. The AI-driven inspection process also increased consistency and objectivity in vehicle assessments, supporting fraud mitigation efforts while improving transparency and operational efficiency across claims and inspection management workflows.",
  },
  {
    id: 11,
    name: 'Vanja Škurić, PhD, MBA',
    altName: 'Vienna Insurance',
    position: 'Head of AI Transformation; Vienna Insurance',
    img: 'vienna-insurance-logo.png',
    flip: 'false',
    text: "As part of Vienna Insurance Group, we hold our technology partners to high standards for accuracy, data protection and compliance. Inspektlabs met those standards and has become a reliable part of our motor claims operations. We would recommend them to any European insurer looking to modernise claims handling.",
  }
];
